export const extractProductIds = (variationGroups) => {
    return variationGroups.map((group) => group.productId)
}

export const selectablesValuesFiltered = (values, groups) => {
    const flatten = extractProductIds(groups)
    return values.filter((value) => flatten.includes(value.value))
}
